import axios from 'axios';

const BASE_URL = process.env.REACT_APP_STRAPI_URL || 'https://cs4.widya.io/strapi';

const strapi = axios.create({
  baseURL: `${BASE_URL}/api`,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const resolveMediaUrl = (media) => {
  if (!media) return null;
  if (typeof media === 'string') return media;
  if (media.url) return media.url;
  if (media.data?.url) return media.data.url;
  if (media.data?.attributes?.url) return media.data.attributes.url;
  return null;
};

export const getStrapiMedia = (media) => {
  if (!media) return null;

  const obj = media?.data?.attributes || media?.data || media;

  let url = obj?.url;

  if (!url && obj?.formats) {
    url = obj.formats.large?.url || obj.formats.medium?.url || obj.formats.small?.url;
  }

  if (!url) {
    url = resolveMediaUrl(media);
  }

  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('//')) return url;

  return `${BASE_URL}${url}`;
};

export const mapStrapiData = (response) => {
  const data = response?.data?.data;
  if (!data) return null;
  if (Array.isArray(data)) {
    return data.map((item) => item.attributes || item);
  }
  return data.attributes || data;
};

export const renderSafeText = (value, fallback = '') => {
  if (!value) return fallback;
  if (typeof value === 'string') return value;

  if (Array.isArray(value)) {
    return value
      .map((block) => {
        if (block.children && Array.isArray(block.children)) {
          return block.children.map((child) => child.text || '').join('');
        }
        return '';
      })
      .join('\n\n');
  }

  if (typeof value === 'object' && value.children) {
    return value.children.map((child) => child.text || '').join('');
  }

  return String(value) || fallback;
};

export { BASE_URL };
export default strapi;